//Imports
import React, { useCallback, useEffect } from "react";

//Controls
import { Button, Modal } from "@gpstrackit/gtc-react-controls";

//Components
import { NotificationManager, NotificationContainer } from "Components/Notifications";

//Hooks
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";

//Actions
import { manageDeleteManageVehicleStatus, reset } from "./redux/slice";

const DeleteManageVehicleStatus = ({ refresh }) => {
  //Redux
  const dispatch = useDispatch();
  const { open, loading, result, error, deleteVehicleStatusList } = useSelector(
    (state) => state.manageDeleteManageVehicleStatusRedux
  );

  //Language
  const { messages } = useIntl();

  //Handlers and utils
  const handleClose = useCallback(() => {
    dispatch(reset());
  }, []);
  const handleDeleteSubmit = useCallback(() => {
    dispatch(manageDeleteManageVehicleStatus({ items: deleteVehicleStatusList }));
  }, [deleteVehicleStatusList]);

  //Effects
  useEffect(() => {
    if (!error) return;
    NotificationManager.error(
      error?.error || messages["errorMessage"],
      messages["error"],
      3000,
      null,
      null,
      "error"
    );
  }, [error]);

  useEffect(() => {
    if (!result) return;
    const messageSuccess =
      !deleteVehicleStatusList?.length > 0
        ? messages["manage_vehicleStatus_deleted"]
        : messages["manage_vehicleStatusList_deleted"];
    NotificationManager.success(messageSuccess, messages["success"], 3000, null, null, "success");
    refresh();
    handleClose()
    dispatch(reset());
  }, [result, deleteVehicleStatusList]);
  return (
    <Modal
      title={
        !deleteVehicleStatusList?.length > 0
          ? messages["manage_deleteVehicleStatus_deleteStatusLabel"]
          : messages["manage_deleteVehicleStatus_deleteStatusLabels"]
      }
      size="small"
      open={open}
      handleClose={handleClose}
      loading={loading}
      footer={
        <div>
          <Button
            variant="secondary"
            style={{ marginRight: "5px" }}
            onClick={() => handleClose()}
            isDisabled={loading}
          >
            {messages["cancel"]}
          </Button>
          <Button variant="warning" onClick={() => handleDeleteSubmit()} isDisabled={loading}>
            {messages["delete"]}
          </Button>
        </div>
      }
    >
      <div style={{ padding: "10px 25px" }}>
        <p>{messages["manage_deleteVehicleStatus_confirmationMessage"]}</p>
        <ul>
          {deleteVehicleStatusList.map((vehicleStatus) => (
            <li>{vehicleStatus.name}</li>
          ))}
        </ul>
      </div>
      <NotificationContainer />
    </Modal>
  );
};

export default DeleteManageVehicleStatus;
